import { BreadcrumbItem } from "common/components/breadcrumb/Breadcrumb";
import { CenterContent } from "common/components/layouts/CenterContent";
import { NormalContentLayout } from "common/components/layouts/NormalContentLayout";
import { NoDataError } from "common/components/NoDataError";
import { isPublished } from "domain/common/utils";
import { ContentList } from "domain/folder/ContentList";
import React from "react";
import { ContentListFragment } from "__generated__/types";

interface Props {
  data: ContentListFragment[] | undefined;
  loadingOrError: React.ReactNode;
  title: string;
  breadcrumbs: BreadcrumbItem[];
  elementUrl: (id: string) => string;
  noDataText: string;
}

export const ContentPage: React.FC<React.PropsWithChildren<Props>> = ({
  data,
  loadingOrError,
  title,
  breadcrumbs,
  elementUrl,
  noDataText,
  children,
}) => {
  return (
    <NormalContentLayout title={title} breadcrumbItems={breadcrumbs}>
      {loadingOrError ? (
        <CenterContent>{loadingOrError}</CenterContent>
      ) : !data ? (
        <NoDataError />
      ) : (
        <>
          {children}
          <ContentList
            contentList={data.filter(isPublished)}
            getUrl={elementUrl}
            noDataText={noDataText}
          />
        </>
      )}
    </NormalContentLayout>
  );
};
